import { useState, useRef, useCallback, useEffect } from 'react'

import { subscribeOpenPostalCodeModal } from '../utils/openPostalCodeModal'

export function usePostalCodeModal(initialState = false) {
  const [showModal, setShowModal] = useState(initialState)
  const ref = useRef<HTMLDivElement>(null)

  const openModal = useCallback(() => setShowModal(true), [])
  const closeModal = useCallback(() => setShowModal(false), [])

  useEffect(() => {
    return subscribeOpenPostalCodeModal(() => {
      if (!ref.current || ref.current.offsetParent === null) {
        return
      }

      setShowModal(true)
    })
  }, [])

  return {
    showModal,
    setShowModal,
    openModal,
    closeModal,
    ref,
  }
}
